"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const debounce_1 = __importDefault(require("lodash/debounce"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const EMPTY_OBJ = {};
const useContainerQuery = (breakpoints = EMPTY_OBJ, debounceTime = 100) => {
    const ref = (0, react_1.useRef)(null);
    const [width, setWidth] = (0, react_1.useState)(0);
    const [height, setHeight] = (0, react_1.useState)(0);
    const matches = (0, react_1.useMemo)(() => {
        const breakpointTest = {};
        Object.keys(breakpoints).forEach((breakpoint) => {
            const { minWidth, maxWidth, minHeight, maxHeight } = breakpoints[breakpoint];
            const isWidthInRange = (!minWidth || width >= minWidth) && (!maxWidth || width <= maxWidth);
            const isHeightInRange = (!minHeight || height >= minHeight) && (!maxHeight || height <= maxHeight);
            breakpointTest[breakpoint] = isWidthInRange && isHeightInRange;
        });
        return breakpointTest;
    }, [breakpoints, height, width]);
    const debouncedResizeCallback = (0, react_1.useCallback)((entries) => {
        setWidth(entries[0].contentRect.width);
        setHeight(entries[0].contentRect.height);
    }, []);
    (0, react_1.useEffect)(() => {
        const element = ref?.current;
        if (!element) {
            return null;
        }
        const resizeObserver = new resize_observer_polyfill_1.default((0, debounce_1.default)((entries) => debouncedResizeCallback(entries), debounceTime));
        resizeObserver.observe(element);
        return () => (resizeObserver ? resizeObserver.disconnect() : null);
    }, [debounceTime, debouncedResizeCallback, ref]);
    return { ref, matches };
};
exports.default = useContainerQuery;
//# sourceMappingURL=useContainerQuery.js.map